


















































































































import {
  MemberManagementMemberDTO,
  MemberManagementMemberService as memberApi,
} from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import { STATUS_ARRAY, TYPES_ARRAY } from "@/model/member";
import { TYPES } from "@/model/order";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    QMultiSelect,
  },
})
export default class MemberListComponent extends Vue {
  public members: MemberManagementMemberDTO[] = [];
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public headers = [];

  public initHeaders = [
    { id: "id", name: "会員ID", order: "desc" },
    { id: "event_number", name: "イベント抽選番号", order: "" },
    { id: "type", name: "区分", order: "" },
    { id: "name", name: "会社名・氏名" },
    { id: "email", name: "メールアドレス" },
    { id: "store_count", name: "ストア" },
    { id: "live_purchase_count", name: "ライブ" },
    { id: "live_purchase_count", name: "初鯉" },
    { id: "status", name: "状態" },
    { id: "", name: "" },
  ];

  public initSearch = {
    types: ["all"],
    statuses: ["all"],
    id: null,
    nameOrCompany: null,
    email: null,
    sort: "id",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};

  public selectedAllType = { id: "all", name: "すべての区分" };
  public searchTypeOptions = [...[this.selectedAllType], ...TYPES_ARRAY];
  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public searchStatusOptions = [...[this.selectedAllStatus], ...STATUS_ARRAY];

  public async mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.initalSearch();
    this.filterData();
  }

  public initalSearch(): void {
    let query = this.$router.currentRoute.query;
    query = this.formatQueryToArray(query, "types");
    query = this.formatQueryToArray(query, "statuses");
    this.searchParams = {
      ...this.initSearch,
      ...query,
    };
  }
  public formatQueryToArray(query, name) {
    if (query[name]) {
      query[name] = Array.isArray(query[name]) ? query[name] : [query[name]];
    }
    return query;
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.types && query.types.includes("all")) {
        query.types = [];
      }

      if (query.statuses && query.statuses.includes("all")) {
        query.statuses = [];
      }
      const result = await memberApi.adminMember(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.members = result.data.members;
    } catch (error) {
      message = error.body.message;
      if (error.body.errors) {
        for (const field in error.body.errors) {
          if (error.body.errors[field].length > 0) {
            message = error.body.errors[field][0];
            break;
          }
        }
      }

      QNotify.error({
        text: message,
      });
    }
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public countStoreOrder(orders = []) {
    return orders.filter((order) => order.type === TYPES.STORE).length;
  }

  public countLiveCarpOrder(orders = []) {
    return orders.filter((order) => order.type === TYPES.LIVE_CARP).length;
  }
}
